import React from 'react';
import { ReactComponent as DetailsIcon } from 'assets/icons/details.svg';
import { Link } from 'react-router-dom';
import { ActivityType } from 'models/activity.model';
import moment from 'moment';

const RecentActivityCard = ({ activity }: { activity: ActivityType }) => {
  const time = moment.utc(activity.created_at).format('hh:mm a');
  const date = moment(activity.created_at).format('MMMM D, YYYY');
  return (
    <section className='pb-8 border-l border-gray-18 pl-8 relative'>
      <div className='absolute w-[30px] h-[30px] rounded-full border border-gray-18 grid place-items-center shadow-sm top-0 left-[-15px] bg-white'>
        <DetailsIcon />
      </div>
      <div className='mb-1 text-xs'>
        <span className='text-gray-6'>{activity.title}</span>
      </div>
      <p className='flex items-center text-xs text-gray-5 mb-3 gap-1'>
        {date} <span className='w-1 h-1 rounded-full bg-gray-10 block'></span> {time}
      </p>
      <div className='border border-gray-18 rounded-md py-3 px-4 flex items-start gap-3'>
        <img src={activity.logo} alt='' className='w-[35px] h-[35px] rounded-full object-cover' />
        <div>
          <p className='text-xs text-gray-5 mb-2.5'>{activity.message}</p>
          <Link to='#' className='text-red-5 underline text-xs'>
            View changes
          </Link>
        </div>
      </div>
    </section>
  );
};

export default RecentActivityCard;
